import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TableModule } from 'primeng/table';
import { DialogModule } from 'primeng/dialog';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { PasswordModule } from 'primeng/password';
import { InputTextModule } from 'primeng/inputtext';
import { InputNumberModule } from 'primeng/inputnumber';
import { FileUploadModule } from 'primeng/fileupload';
import { CheckboxModule } from 'primeng/checkbox';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { MessagesModule } from 'primeng/messages';
import { SelectButtonModule } from 'primeng/selectbutton';
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { TagModule } from 'primeng/tag';
import { ColorPickerModule } from 'primeng/colorpicker';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { CardModule } from 'primeng/card';
import { TabViewModule } from 'primeng/tabview';
import { InputMaskModule } from 'primeng/inputmask';
import { MultiSelectModule } from 'primeng/multiselect';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { TooltipModule } from 'primeng/tooltip';
import { PaginatorModule } from 'primeng/paginator';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { EditorModule } from 'primeng/editor';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { GalleriaModule } from 'primeng/galleria';
import { DataViewModule } from 'primeng/dataview';
import { ChartModule } from 'primeng/chart';
import { ListboxModule } from 'primeng/listbox';
import { ChipsModule } from 'primeng/chips';
import { BadgeModule } from 'primeng/badge';
import { ButtonGroupModule } from 'primeng/buttongroup';
import { OrganizationChartModule } from 'primeng/organizationchart';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { DividerModule } from 'primeng/divider';
import { FieldsetModule } from 'primeng/fieldset';
import { GravatarPipe } from '@app/core/pipes/gravatar.pipe';
import { ShortTextPipe } from '@app/core/pipes/short-text.pipe';
import { FormatBytesPipe } from '@app/core/pipes/format-bytes.pipe';
import { HasPermissionPipe } from '@app/core/pipes/has-permission.pipe';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { BooleanStatusComponent } from './components/boolean-status/boolean-status.component';
import { ResolveFieldDataComponent } from './components/resolve-field-data/resolve-field-data.component';
import { CarFormatComponent } from './components/car-format/car-format.component';
import { CarAutocompleteComponent } from './components/car-autocomplete/car-autocomplete.component';
import { CityAutocompleteComponent } from './components/city-autocomplete/city-autocomplete.component';
import { PlaceAutocompleteComponent } from './components/place-autocomplete/place-autocomplete.component';
import { NgxScannerQrcodeModule, LOAD_WASM } from 'ngx-scanner-qrcode';
import { ResolveFieldDataPipe } from '@app/core/pipes/resolve-field-data.pipe';
import { FormatDurationPipe } from '@app/core/pipes/format-duration.pipe';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { BooleanPipe } from '@app/core/pipes/boolean.pipe';
import { IssueTimeLogActivityPipe } from '@app/core/pipes/issue-time-log-activity.pipe';



LOAD_WASM().subscribe();


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        FileUploadModule,
        AutoCompleteModule,
        TagModule,
        DialogModule,
        DropdownModule
    ],
    declarations: [
        GravatarPipe,
        ShortTextPipe,
        FormatBytesPipe,
        HasPermissionPipe,
        ResolveFieldDataPipe,
        IssueTimeLogActivityPipe,
        BooleanPipe,
        FormatDurationPipe,
        BooleanStatusComponent,
        CarFormatComponent,
        CarAutocompleteComponent,
        CityAutocompleteComponent,
        PlaceAutocompleteComponent,
        ResolveFieldDataComponent
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        ConfirmDialogModule,
        TableModule,
        DialogModule,
        PasswordModule,
        InputTextModule,
        FileUploadModule,
        CheckboxModule,
        AutoCompleteModule,
        MessagesModule,
        SelectButtonModule,
        ButtonGroupModule,
        PaginatorModule,
        CalendarModule,
        DropdownModule,
        ColorPickerModule,
        InputMaskModule,
        InputNumberModule,
        MultiSelectModule,
        InputTextareaModule,
        ToggleButtonModule,
        TooltipModule,
        ChartModule,
        DynamicDialogModule,
        BreadcrumbModule,
        ProgressSpinnerModule,
        GalleriaModule,
        DataViewModule,
        TabViewModule,
        DividerModule,
        TagModule,
        FieldsetModule,
        ChipsModule,
        BadgeModule,
        ListboxModule,
        CardModule,
        ScrollPanelModule,
        NgxScannerQrcodeModule,
        GravatarPipe,
        ShortTextPipe,
        FormatBytesPipe,
        HasPermissionPipe,
        BooleanPipe,
        ResolveFieldDataPipe,
        FormatDurationPipe,
        IssueTimeLogActivityPipe,
        BooleanStatusComponent,
        ResolveFieldDataComponent,
        CarFormatComponent,
        CarAutocompleteComponent,
        CityAutocompleteComponent,
        PlaceAutocompleteComponent,
        FontAwesomeModule,
        EditorModule,
        OrganizationChartModule,
        LeafletModule
    ]
})
export class SharedModule { }
